var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0902 20.7845L4 24L6.76039 12.7878L10.2039 16.0936L15.7586 10.3075C15.9472 10.111 16.2077 10 16.48 10C16.7523 10 17.0128 10.111 17.2014 10.3075L21.28 14.556L27.2786 8.30747C27.6611 7.90906 28.2941 7.89614 28.6925 8.27861C29.0909 8.66109 29.1039 9.29412 28.7214 9.69253L22.0014 16.6925C21.8128 16.889 21.5523 17 21.28 17C21.0077 17 20.7472 16.889 20.5586 16.6925L16.48 12.444L11.6467 17.4787L15.0902 20.7845Z",
    fill: "#D9342B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/ArrowDown.6f6e018b928e825a2ab1bdae6e0bf2ef.svg";
export { ForwardRef as ReactComponent };